import React from "react"
import clsx from "clsx"
import I18n from "i18n-js"
//import I18n from "i18n-js/index.js.erb"

class CancellationRulePresenterGeneral extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    return(
      <div className={tabClasses} id="general">
        <div className="cancellation-rule">
          <div className="row">
            <div className="col-sm-2">
              <div className="form-group ">
                <label>{I18n.t('code')}</label>
                <div>{this.props.code}</div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label>{I18n.t('name')}</label>
                <div>{this.props.name}</div>
              </div>
            </div>
            <div className="col-sm-6">
              <label></label>
              <div className="form-inline form-sentence text-center">
                {I18n.t('reservations_cancelled')} &nbsp;
                <div className="input-group input-group-numeric" style={{marginLeft: 'auto', marginRight: 'auto', position: 'relative', top: -2}}>
                  <span>{`${this.props.time_value}    ${I18n.t('days')}`}</span>
                </div>
                <span> &nbsp;</span>
              </div>
              {I18n.t('or_less_before_check_in_date_will_incur_the_following_cost')}:
            </div>
          </div>
          <br/>

          <div className="row" style={{marginBottom: 10}}>
            <div className="panel panel-default col">
              <div className="panel-body container flexed ">
                <div className="col-sm-3">
                  <div className="form-group ">
                    <label>{I18n.t('percentage_of_lodging')} <span className="ss-help help" title={I18n.t('cancellation_rule_percentage_of_lodging_helper_text')}></span></label>
                      <div>{this.props.percentage ? (this.props.percentage * 100) + '%' : ''}</div>
                  </div>
                </div>

                <div className="col-md-3 justify-content-center align-items-center">
                  <div className="text-center" style={{fontStyle: 'italic', fontWeight: 'bold', marginTop: '30px'}}>{I18n.t('or')}</div>
                </div>
                <div className="col-sm-6 float-right">
                  <div className="form-group ">
                    <label>{I18n.t('custom_cancellation_rule')} <span className="ss-help help" title={I18n.t('cancellation_rule_custom_based_helper_text')}></span></label>
                    <div>{this.props.custom_rule}</div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }

}

export default CancellationRulePresenterGeneral
